import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@core/models/api-response.model";
import { Pagination } from "@core/models/pagination.model";
import { Observable, Subject } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable()
export class AffiliateCampaignsDataService {

    pagination: Pagination;
    messages$ = new Subject<any[]>();

    constructor(
        private http: HttpClient,
    ) { }

    getWithQuery(pageParam?: string): Observable<any[]> {
        return this.http.get<ApiResponse>(`/affiliate/campaign${pageParam}`).pipe(
            tap(res => this.paginationInit(res)),
            map(res => res.data.rows)
        );
    }

    // Emits to messages$ so the queued-report confirmation — and the 422 raised when an
    // identical report is still pending — both surface to the operator.
    exportAffiliateCampaigns(pageParam: string) {
        return this.http.get<ApiResponse>(`/affiliate/campaign/export${pageParam}`).pipe(
            tap(res => this.messages$.next(res.message))
        );
    }

    getPromotions(): Observable<any[]> {
        return this.http.get<ApiResponse>(`/promotiondropdown?paginate=false`).pipe(
            map(res => res.data.rows)
        );
    }

    // Feeds the Affiliate multi-select. Returns { id, username, status } and is
    // ACTIVE-affiliates only (Affiliate::getDropdownData filters on CODE_STATUS_ACTIVE).
    getAffiliates(): Observable<any[]> {
        return this.http.get<ApiResponse>(`/affiliatedropdown?paginate=false`).pipe(
            map(res => res.data.rows)
        );
    }

    private paginationInit(res: any) {
        if (res) {
            this.pagination = res.data.paginations;
        }
    }

}
